import { ARTICLE_NUMBER_PER_PAGE, apiUri } from '../appConfig';

const scheduleList = (from = 0, count = ARTICLE_NUMBER_PER_PAGE) => (
	fetch(`${apiUri}/schedule?from=${from}&take=${count}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default scheduleList;



// WEBPACK FOOTER //
// ./src/js/request/scheduleList.js